import { Pipe, PipeTransform } from "@angular/core";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";

@Pipe({
  name: "filterOutBooking"
})
export class FilterOutBookingPipe implements PipeTransform {
  transform(allBookings: NsEmpWebExpData.IList[], booking: NsEmpWebExpData.IBookingDetailDTOS): NsEmpWebExpData.IList[] {
    if (!booking || !allBookings) {
      return allBookings;
    }
    return allBookings.filter(b => b.booking.bookingRequestId !== booking.bookingRequestId);
  }
}
